import Cookies from 'js-cookie';

const userKey = '_code_user';
let userSessionType = -1;

function getCookie() {
  if (userSessionType === 0) {
    return Cookies.get(userKey);
  }
  if (userSessionType === 1) {
    return sessionStorage.getItem(userKey);
  }

  return null;
}

const setCookie = (data) => {
  if (!data || data === null) {
    return;
  }

  if (userSessionType === 0) {
    Cookies.set(userKey, data, {
      expires: 365
    });
  } else {
    sessionStorage.setItem(userKey, data);
  }
};

const removeCookie = () => {
  if (userSessionType === 0) {
    Cookies.remove(userKey);
  } else {
    sessionStorage.removeItem(userKey);
  }
};

const setUserSessionType = (type) => {
  userSessionType = type;
};

const getUserSessionType = () => userSessionType;

export {
  getCookie,
  setCookie,
  removeCookie,
  setUserSessionType,
  getUserSessionType
};
